import { render, staticRenderFns } from "./QuoteAnnotations.vue?vue&type=template&id=34a1dbe4"
import script from "./QuoteAnnotations.vue?vue&type=script&lang=js"
export * from "./QuoteAnnotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports